import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// SEGURANÇA: autenticação exclusivamente via cookie httpOnly (withCredentials).
// Nenhum token JWT é persistido em localStorage nem enviado manualmente em header.

// Interceptor: injeta X-Active-Base do localStorage em toda request
api.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem("chemwms_active_base");
    if (raw) {
      const base = JSON.parse(raw);
      if (base && base.code) {
        config.headers["X-Active-Base"] = base.code;
      }
    }
  } catch (e) { /* noop */ }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Erro inesperado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
